import { render, staticRenderFns } from "./editList.vue?vue&type=template&id=2a6aa76e&scoped=true&"
import script from "./editList.vue?vue&type=script&lang=js&"
export * from "./editList.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2a6aa76e",
  null
  
)

export default component.exports